import { render, staticRenderFns } from "./KioskLayoutV2.vue?vue&type=template&id=21012e8b&scoped=true"
import script from "./KioskLayoutV2.vue?vue&type=script&lang=js"
export * from "./KioskLayoutV2.vue?vue&type=script&lang=js"
import style0 from "./KioskLayoutV2.vue?vue&type=style&index=0&id=21012e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21012e8b",
  null
  
)

export default component.exports